import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";

// Sentry — loaded from CDN when configured, so it's not a bundle dependency
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  const s = document.createElement("script");
  s.src = "https://browser.sentry-cdn.com/7.119.0/bundle.min.js";
  s.crossOrigin = "anonymous";
  s.async = true;
  s.onload = () => {
    if (window.Sentry) {
      window.Sentry.init({
        dsn: SENTRY_DSN,
        environment: process.env.NODE_ENV,
        tracesSampleRate: 0.1,
      });
    }
  };
  document.head.appendChild(s);
}

const rootEl = document.getElementById("root");
const app = (
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Support react-snap prerender: hydrate if pre-rendered HTML exists,
// otherwise render fresh.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, app);
} else {
  ReactDOM.createRoot(rootEl).render(app);
}

reportWebVitals();
